/**
 * ICS Calendar File Generator
 *
 * Generates and triggers download of a standard .ics calendar file.
 * Used by both BookingPage (embedded flow) and BookingSuccessPage (post-payment).
 *
 * @param {Object} params
 * @param {string} params.serviceName       - Name of the service/session
 * @param {string} params.practitionerName  - Practitioner's display name
 * @param {string} params.dateTimeISO       - Full ISO 8601 datetime string, e.g. "2026-03-05T10:15:00-08:00"
 * @param {number} params.duration          - Session duration in minutes
 */
export function downloadICS({ serviceName, practitionerName, dateTimeISO, duration }) {
  const startDate = new Date(dateTimeISO);
  const endDate = new Date(startDate.getTime() + (duration || 60) * 60000);

  const formatICSDate = (date) =>
    date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

  const summary = `${serviceName} with ${practitionerName || 'Practitioner'}`;
  const description =
    `${serviceName} session with ${practitionerName || 'Practitioner'}` +
    `\\nDuration: ${duration} minutes` +
    `\\n\\nBooked through Divine Frameworks`;

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Divine Frameworks//Booking//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `DTSTART:${formatICSDate(startDate)}`,
    `DTEND:${formatICSDate(endDate)}`,
    `SUMMARY:${summary}`,
    `DESCRIPTION:${description}`,
    'STATUS:CONFIRMED',
    `UID:${Date.now()}@divineframeworks.com`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${(serviceName || 'session').replace(/\s+/g, '-')}-booking.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
